import React from 'react';
import { Link } from 'react-router-dom';
import '../styles/Footer.css';

const Footer = () => {
  return (
    <footer className="footer">
      <div className="footer-top">
        <div className="container">
          <div className="footer-content">
            <div className="footer-column company-info">
              <h3>PHG Danışmanlık</h3>
              <p>
                Yenilik, Güven ve Şeffaflık ilkelerini benimseyerek profesyonel bir şekilde çıktığımız bu yolda
                ülkemizdeki ve yurtdışındaki bağlantılarımızla müşterilerimizi memnun ediyoruz.
              </p>
              <div className="social-icons">
                <a href="https://www.linkedin.com/in/phg-dan%C4%B1%C5%9Fmanl%C4%B1k-37b8a4231" className="social-icon" target="_blank" rel="noopener noreferrer"><i className="fab fa-linkedin-in"></i></a>
                <a href="https://www.instagram.com/phg_danismanlik/" className="social-icon" target="_blank" rel="noopener noreferrer"><i className="fab fa-instagram"></i></a>
              </div>
            </div>
            
            <div className="footer-column">
              <h3>Hizmetlerimiz</h3>
              <ul className="footer-links">
                <li><Link to="/hizmetlerimiz#mavi-kart">Mavi Kart (Blue Card)</Link></li>
                <li><Link to="/hizmetlerimiz#istisna-akdi">İstisna Akdi</Link></li>
                <li><Link to="/hizmetlerimiz#yeni-goc-yasasi">Yeni Göç Yasası</Link></li>
              </ul>
            </div>
            
            <div className="footer-column">
              <h3>Hızlı Bağlantılar</h3>
              <ul className="footer-links">
                <li><Link to="/kurumsal">Kurumsal</Link></li>
                <li><Link to="/kurumsal">Hakkımızda</Link></li>
                <li><Link to="/ulkeler">Ülkeler</Link></li>
                <li><Link to="/iletisim">İletişim</Link></li>
              </ul>
            </div>
            
            <div className="footer-column contact-info">
              <h3>İletişim</h3>
              <ul className="contact-details">
                <li>
                  <i className="fas fa-map-marker-alt"></i>
                  <div className="contact-text">
                    <span>Hacettepe, Yılmaz Çk. No:3, 06230 Altındağ/Ankara</span>
                  </div>
                </li>
                <li>
                  <i className="fas fa-phone"></i>
                  <div className="contact-text">
                    <span>+90 532 509 25 75</span>
                  </div>
                </li>
                <li>
                  <i className="fas fa-envelope"></i>
                  <div className="contact-text">
                    <span>info@phgdanismanlik.com</span>
                  </div>
                </li>
                <li>
                  <i className="fas fa-clock"></i>
                  <div className="contact-text">
                    <div>Pazartesi - Cuma: 09:00 - 18:00</div>
                    <div>Cumartesi: 09:00 - 13:00</div>
                  </div>
                </li>
              </ul>
            </div>
          </div>
        </div>
      </div>
      
      <div className="footer-bottom">
        <div className="container">
          <p className="copyright">© 2025 PHG Danışmanlık & Müşavirlik. Tüm hakları saklıdır.</p>
          <p className="copyright">Made by Nephos</p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;